import { api } from './config'

export function logouts (sessId) {
  return api.post('/logouts', {
    sessId: sessId
  })
}
